export const cTipoRefacturacion = {
    normal: 1,
    dpi: 2,
    nit: 3
}